<template>
  <div class="AboutDesign">
    <HeaderTop class="about-bg"/>
    <div class="w about-bg about-bg-padding">
      <div class="container clearfix">
        <div class="container-left" style="min-height:300px" :style="{height:divHeight +'px'}">
          <ul>
            <li><router-link  to="/aboutdesign/about" @click.native="goAbout"><i class="iconfont icon-zhengfangxing-"></i>锦龙名车中心</router-link></li>
            <li><router-link :class="activityTypeId == 1 ? 'router-link-active' : ''" to="/aboutdesign/activity" @click.native="goAbout(activityTypeId)"><i class="iconfont icon-zhengfangxing-"></i>活动特惠</router-link></li>
            <li><router-link :class="activityTypeId == 2 ? 'router-link-active' : ''" to="/aboutdesign/service" @click.native="goAbout(activityTypeId)"><i class="iconfont icon-zhengfangxing-"></i>每日信息</router-link></li>
            <li><router-link :class="activityTypeId == 3 ? 'router-link-active' : ''" to="/aboutdesign/problem" @click.native="goAbout(activityTypeId)"><i class="iconfont icon-zhengfangxing-"></i>常见问题</router-link></li>
          </ul>
        </div>
        <div class="container-left-mode">
          <ul>
            <li><router-link  to="/aboutdesign/about" @click.native="goAbout"><i class="iconfont icon-zhengfangxing-"></i>锦龙名车中心</router-link></li>
            <li><router-link :class="activityTypeId == 1 ? 'router-link-active' : ''" to="/aboutdesign/activity" @click.native="goAbout(activityTypeId)"><i class="iconfont icon-zhengfangxing-"></i>活动特惠</router-link></li>
            <li><router-link :class="activityTypeId == 2 ? 'router-link-active' : ''" to="/aboutdesign/service" @click.native="goAbout(activityTypeId)"><i class="iconfont icon-zhengfangxing-"></i>每日信息</router-link></li>
            <li><router-link :class="activityTypeId == 3 ? 'router-link-active' : ''" to="/aboutdesign/problem" @click.native="goAbout(activityTypeId)"><i class="iconfont icon-zhengfangxing-"></i>常见问题</router-link></li>
          </ul>
        </div>
        <div ref="divHeight" @load="divLoad" class="container-right">
          <router-view></router-view>
        </div>
      </div>
      <div class="line"></div>
      <FooterAbout class="no-margin"/>
    </div>
    <Copy/>
  </div>
</template>

<script>
import PubSub from 'pubsub-js'
import HeaderTop from '../components/HeaderTop.vue'
import FooterAbout from '../components/FooterAbout.vue'
import Cookies from 'js-cookie'
import Copy from '../components/Copy.vue'

export default {
  name: 'AboutDesign',
  inject: ['reload'],
  data () {
    return {
      divHeight: '',
      activityTypeId: ''
    }
  },
  created () {
    PubSub.subscribe('activityTypeId', (msg, activityTypeId) => {
      return this.activityTypeId = activityTypeId
    })
  },
  methods: {
    divLoad() {
      console.log('333333', this.$refs.divHeight)
      this.$nextTick(()=>{
        console.log('222222', this.$refs.divHeight.offsetHeight)
        this.divHeight = this.$refs.divHeight.offsetHeight
        console.log('1111111', this.divHeight)
      })
    },
    goAbout() {
      this.reload()
    },
  },
  mounted () {
    this.divLoad()

    const that = this
    window.addEventListener('resize', () => {
      that.divHeight = that.$refs.divHeight.offsetHeight
      that.divLoad()
    }, false)
  },
  components: {
    HeaderTop,
    FooterAbout,
    Copy
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../css-styl/mixins.styl'

  .AboutDesign
    background #f5f5f5
    .about-bg-padding
      margin-top 37px
    .about-bg
      background #fff
      .container
        border 1px solid #e4e4e4
        border-radius 6px
        .container-left
          width 18%
          padding-right 1%
          background #f7f7f7
          float left
          ul
            margin 60px 20px 0
            border-top 1px solid #e5e5e5
            li
              border-bottom 1px solid #e5e5e5
              height 59px
              a
                color #666
                font 400 16px/60px "Microsoft YaHei"
                display block
                padding-left 0
                i
                  font-size 14px
                  margin 0 7px 0 30px
              .router-link-active
                padding 0 !important
                // padding-left 60px !important
                top 0 !important
                color #d81240 !important
                background 0 !important
        .container-left-mode
          display none
          width 100%
          margin-top 20px
          ul
            li
              float left    
              margin-right 2%
              width 22%
              &:nth-of-type(1)
                margin-left 3%
              a
                font 400 14px/40px "Microsoft YaHei"
                text-align center
                color #fff
                background #666
                display block
                padding 0 12px
                border-radius 6px
                i
                  font-size 12px
                  margin 0 8px 0 0 
              .router-link-active
                background #d81240 !important
                display block !important
                padding 0 12px !important
                // padding-left 60px !important
                top 0 !important
                color #fff !important
        .container-right
          width 77%
          min-height 300px
          padding 0 2% 20px
          float left
          border-left 1px solid #e4e4e4
          box-sizing border-box
      .line
        height 30px
        background #f5f5f5
      .no-margin
        margin-top 0 !important

  @media screen and (min-width: 990px) and (max-width: 1050px)
    .AboutDesign .about-bg .container .container-left ul li
      i
        margin 0 7px 0 10px !important
  @media screen and (min-width: 100px) and (max-width: 989px)
    .AboutDesign .about-bg .container .container-left ul
      margin 60px 10px 0 !important
      li
        i
          margin 0 7px 0 10px !important
  @media screen and (min-width: 800px) and (max-width: 834px)
    .AboutDesign .about-bg .container .container-left 
      ul
        li
          height 48px
          a
            font-size 14px
  @media screen and (min-width: 100px) and (max-width: 799px)
    .AboutDesign .about-bg .container 
      .container-left
        display none
      .container-left-mode
        display block
      .container-right
        width 100%
  @media screen and (min-width: 100px) and (max-width: 510px)
    .AboutDesign .about-bg .container 
      .container-left-mode
        ul li a
          font-size 13px
          i 
            margin 0 1px 0 0 !important
  @media screen and (min-width: 100px) and (max-width: 414px)
    .AboutDesign .about-bg .container 
      .container-left-mode ul li
        width 22%
        a
          padding 0 6px
        .router-link-active
          padding 0 6px !important
  @media screen and (min-width: 100px) and (max-width: 370px)
    .AboutDesign .about-bg .container 
      .container-left-mode ul li
        width 44%
        margin-right 4%
        margin-bottom 16px
        &:nth-of-type(1)
          margin-left 4%
        &:nth-of-type(3)
          margin-left 4%

</style>



// WEBPACK FOOTER //
// src/pages/AboutDesign.vue